import * as ActionTypes from '@storeOld/actions'
import { LOCATION_CHANGE } from 'redux-first-history'
import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { AccountActions, InternalAccountActions } from '../actions'
import { changeEmail } from './changeEmail'
import { loadEmailsOnAccount } from './loadEmailsOnAccount'
import { remove } from './remove'
import { syncTimezone } from './syncTimezone'
import { update } from './update'
import { updateEmails } from './updateEmails'
import { updateRequest } from './updateRequest'
import { verifyOtp } from './verifyOtp'

export function* accountSaga() {
  yield all([
    takeEvery(AccountActions.update, update),
    takeLatest(InternalAccountActions.updateRequest, updateRequest),
    takeEvery(AccountActions.delete, remove),
    takeEvery(AccountActions.changeEmail, changeEmail),
    takeLatest(AccountActions.verifyOtp, verifyOtp),
    takeLatest(LOCATION_CHANGE, loadEmailsOnAccount),
    takeEvery(AccountActions.updateEmails, updateEmails),
    // the zone follows the browser: checked on every auth load, saved when it moved
    takeLatest(ActionTypes.SET_AUTH, syncTimezone),
  ])
}
